import { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { Copy, FileDown, ImageDown, QrCode, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { RL } from "@/components/partner/reportI18n";

async function dl(url, name) {
  try {
    const r = await api.get(url, { responseType: "blob", timeout: 60000 });
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: name });
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (e) { toast.error(errMsg(e)); }
}

export function QrPanel({ token, code, query, lang }) {
  const [open, setOpen] = useState(false);
  const t = RL[lang];
  const link = `${window.location.origin}/laporan/${token}`;
  const origin = encodeURIComponent(window.location.origin);
  const sep = query ? "&" : "?";
  const btn = "inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-4 py-2 text-xs font-semibold transition-colors hover:bg-accent";
  return (
    <>
      <button data-testid="report-qr-button" onClick={() => setOpen((o) => !o)} className={`${btn} ${open ? "border-primary text-primary" : ""}`}><QrCode className="h-3.5 w-3.5" />{t.qr}</button>
      {open && createPortal(
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-foreground/30 p-4 backdrop-blur-sm sm:items-center" onClick={() => setOpen(false)} data-testid="report-qr-overlay">
          <div className="soft-card w-full max-w-md !p-6" onClick={(e) => e.stopPropagation()} data-testid="report-qr-panel">
            <div className="flex items-start justify-between gap-3">
              <div><p className="text-xs uppercase tracking-wide text-muted-foreground">{t.sub}</p><h3 className="mt-1 font-jpserif text-xl">{t.qrTitle}</h3></div>
              <button data-testid="report-qr-close" onClick={() => setOpen(false)} className="rounded-full border border-border p-1.5 hover:bg-accent" aria-label="close"><X className="h-4 w-4" /></button>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">{t.qrHint}</p>
            <div className="mt-4 flex flex-col items-center gap-3 sm:flex-row sm:items-start">
              <img data-testid="report-qr-image" src={`${process.env.REACT_APP_BACKEND_URL}/api/guide/qr?url=${encodeURIComponent(link)}`} alt="QR" className="h-40 w-40 shrink-0 rounded-xl border border-border bg-white p-1.5" />
              <div className="min-w-0 flex-1">
                <p className="break-all text-[11px] text-muted-foreground" data-testid="report-qr-link">{link}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  <button data-testid="report-qr-pdf" onClick={() => dl(`/partner/me/report-qr.pdf${query}${sep}origin=${origin}`, `qr-laporan-${code}.pdf`)} className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground"><FileDown className="h-3.5 w-3.5" />{t.qrPdf}</button>
                  <button data-testid="report-qr-png" onClick={() => dl(`/partner/me/report-qr.png${query}${sep}origin=${origin}`, `qr-laporan-${code}.png`)} className={btn}><ImageDown className="h-3.5 w-3.5" />PNG</button>
                  <button data-testid="report-qr-copy" onClick={() => { navigator.clipboard?.writeText(link); toast.success(t.qrCopied); }} className={btn}><Copy className="h-3.5 w-3.5" />{t.qrCopy}</button>
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
